import React, {useEffect, useState} from 'react'
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material'
import {useLocation, useNavigate} from 'react-router-dom'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import {useAuth} from './auth'
import {fetchBins} from '../inventory/utils'
import {webEvents} from '../common/WebEvents'
import {NOT_CLOCKED_IN} from '../common/ApiError'

function ManageClockIn() {
    const {clockIn, getUser, clockOut, logout} = useAuth()
    const navigate = useNavigate()
    const {state} = useLocation()
    const [clockedIn, setClockedIn] = useState(false)
    const [openDialog, setOpenDialog] = useState(false)

    useEffect(() => {
        fetchBins()
            .then(() => {
                let user = getUser()
                if (user.clocked_in) {
                    setClockedIn(true)
                }
            })
            .catch(error => {
                webEvents.error(
                    error.message,
                    error.stack
                )
                if (error.type === NOT_CLOCKED_IN) {
                    setClockedIn(false)
                }
            })
    }, [])


    const handleClockIn = async () => {
        await clockIn()
        navigate(state?.path || '/')
    }

    const handleClose = () => {
        setOpenDialog(false)
    }

    const handleConfirm = async () => {
        await clockOut()
        logout()
    }

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            px={4}
            py={8}
        >
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" px={6} py={8}>
                <Typography variant="h5" align="center" fontWeight="bold" color="textPrimary">
                    {clockedIn ? 'You are currently clocked in' : 'You are not clocked in, please clock in to continue'}
                </Typography>
            </Box>
            <Box display="flex" justifyContent="center" mt={2} width="100%">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleClockIn}
                    startIcon={<AccessTimeIcon />}
                    sx={{margin: '0 5px'}}
                    disabled={clockedIn}
                >
                    Clock In
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => setOpenDialog(true)}
                    startIcon={<AccessTimeIcon />}
                    sx={{margin: '0 5px'}}
                    disabled={!clockedIn}
                >
                    Clock Out
                </Button>
            </Box>

            <Dialog
                open={openDialog}
                onClose={handleClose}>
                <DialogTitle>
                    Confirm Clock Out
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        You will be logged out once you clock out. Please confirm if you wish continue.
                    </Typography>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}>
                    <Button onClick={handleClose} color="error">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirm}
                        color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default ManageClockIn
